var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4394 0C16.7804 0 18.0704 0.53 19.0194 1.481C19.9694 2.43 20.5004 3.71 20.5004 5.05V12.95C20.5004 15.74 18.2304 18 15.4394 18H5.56037C2.76937 18 0.500366 15.74 0.500366 12.95V5.05C0.500366 2.26 2.75937 0 5.56037 0H15.4394ZM17.0304 6.54L17.1104 6.46C17.3494 6.17 17.3494 5.75 17.0994 5.46C16.9604 5.311 16.7694 5.22 16.5704 5.2C16.3604 5.189 16.1604 5.26 16.0094 5.4L11.5004 9C10.9204 9.481 10.0894 9.481 9.50037 9L5.00037 5.4C4.68937 5.17 4.25937 5.2 4.00037 5.47C3.73037 5.74 3.70037 6.17 3.92937 6.47L4.06037 6.6L8.61037 10.15C9.17037 10.59 9.84937 10.83 10.5604 10.83C11.2694 10.83 11.9604 10.59 12.5194 10.15L17.0304 6.54Z",
    fill: "#130F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.674aff5cbf5d54bc73bdb8aa8dbdb55c.svg";
export { ForwardRef as ReactComponent };